export const ELLIPSIS = '...';

// The page items the `pipeline_2` frame draws (1-based): first and last always, a five-page window
// centred on the current page and kept inside 1..N, "..." where a gap remains. Drawn: page 1 of 100
// -> 1 2 3 4 5 ... 100; page 50 -> 1 ... 48 49 50 51 52 ... 100. Not drawn, our defaults: N <= 7
// lists every page, and a gap of exactly one page shows that page instead of "...".
export function getPageItems(current, total) {
  if (total <= 0) return [];
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);

  const page = Math.min(Math.max(current, 1), total);
  let start = Math.max(1, page - 2);
  let end = Math.min(total, start + 4);
  start = Math.max(1, end - 4);

  const items = [];
  if (start > 1) {
    items.push(1);
    if (start === 3) items.push(2);
    else if (start > 3) items.push(ELLIPSIS);
  }
  for (let p = start; p <= end; p += 1) items.push(p);
  if (end < total) {
    if (end === total - 2) items.push(total - 1);
    else if (end < total - 2) items.push(ELLIPSIS);
    items.push(total);
  }
  return items;
}
